/* xs-docs v1.0 (2026-09-23) — product page Downloads block for LS / PL, ported from VK vk-pdp.js ⑤ (docs / mfKinds / placeholder cleanup).
   Rules (老板 0922/0923):
   1. metafields are the only source of truth: a kind (spec/asm/3d/dim) that has a metafield card → the description's download row of that kind is removed, never merged;
      「类型 | none」 in custom.downloads hides that kind (description leftovers included);
   2. dead placeholder buttons (href="#", "X_URL", "1", plain-text "Download" rows / .action-btn without a link) are removed always; a group left with only placeholders goes as a whole;
   3. when the block has no metafield card at all the description's real download links are left untouched (block stays hidden);
   4. real description links of a kind the metafields do not cover are merged into the block as cards (same look) and their rows removed. */
(function () {
  'use strict';
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function txt(el) { if (!el) return ''; var c = el.cloneNode(true); $$('svg, style, script', c).forEach(function (x) { x.parentNode.removeChild(x); }); return (c.textContent || '').replace(/\s+/g, ' ').trim(); }
  var ROOTS = '.product__description .rte, .product__description.rte, .accordion.xs-desc .accordion__content, .product-tabs__tab-text.rte';
  var HEAD_WORDS = /^(spec ?sheets?|specifications?|installation( guide)?|install guide|instructions?|downloads?( (&|and) resources)?|documents?|technical documents?|manufacturer resources|3d ?(models?|files?)|user manual|manual|dimension drawings?|download support|resources)$/i;
  var GENERIC = /^(specs?|spec sheets?|specifications?|full specifications?|specification sheets?|data sheets?|install(ation)?( guide| sheet)?|installation instructions?|assembly( guide| instructions?)?|instructions?|user manual|manual|3d ?(files?|models?)|downloads?|documents?|dimension drawings?|drawings?)$/;
  var DEAD_HREF = /^(#?|\d{0,2}|javascript:.*|[A-Z0-9_]*_URL|REPLACE_WITH[A-Z0-9_]*)$/;
  var JUNK = /^(download( now)?|click here|here|pdf|link|view|i)?$/i;
  var WRONG = {};   // Drive ids copied onto unrelated products (VK 0921 audit) → kept only when the title matches; none known for LS/PL yet
  function norm(l) { return (l || '').toLowerCase().replace(/ /g, ' ').replace(/[↓⬇→☛]/g, ' ').replace(/\((?:\.?pdf|both sizes,? ?pdf|png|zip)\)/g, ' ').replace(/\bpdf\s*·\s*(spec sheet|install guide|shade guide)\b/g, ' ').replace(/\b(download|pdf|file download)\b/g, ' ').replace(/\s+/g, ' ').replace(/^[\s\-:·\/]+|[\s\-:·\/]+$/g, ''); }
  function kindOf(label) {
    var l = norm(label); if (!l) return '';
    if (/^(3d ?(files?|models?)( for specifiers)?|3d)$/.test(l)) return '3d';
    if (/^(full )?(specs?|spec sheets?|specifications?|specification sheets?|data sheets?|technical (data|specifications?)|product specifications?)$/.test(l)) return 'spec';
    if (/^(installation( guide| instructions?| manual| sheet)?( [ab])?|install(ation)? guide|assembly( guide| instructions?)?|instructions?|user manual|manual|setup guide|mounting guide|installation and safety guide)$/.test(l)) return 'asm';
    if (/^(dimensions?( drawing)?|dimension drawings?|drawings?|size chart|size guide)$/.test(l)) return 'dim';
    return '';
  }
  function family(label, href) { var l = norm(label) + ' ' + (href || '').toLowerCase(); if (/\b3d\b|\.(igs|iges|step|stp|3ds|dwg|dxf|obj|fbx|skp)\b/.test(l)) return '3d'; if (/install|assembl|instruction|manual|setup|mounting/.test(l)) return 'asm'; if (/spec|data sheet/.test(l)) return 'spec'; if (/dimension|drawing|size chart|size guide/.test(l)) return 'dim'; return ''; }
  function unwrap(a) { var p = a.parentNode; if (!p) return; while (a.firstChild) p.insertBefore(a.firstChild, a); p.removeChild(a); }
  function docId(h) { var m = /\/d\/([\w-]{10,})/.exec(h); return m ? m[1] : h.replace(/[?#].*$/, ''); }
  function isDoc(href, kind) {
    if (!/^https?:/i.test(href) || /\/(products|blogs|pages|collections)\//i.test(href) || /drive\.google\.com\/drive\/folders\//i.test(href)) return false;
    if (/\.(png|jpe?g|webp|gif)(\?|$)/i.test(href)) return !!kind;
    return /(drive|docs)\.google\.com|dropbox\.com|1drv\.ms|box\.com/i.test(href) || /\.(pdf|zip|rar|7z|step|stp|igs|iges|dwg|dxf|skp|obj|fbx|3ds|max)(\?|$)/i.test(href);
  }
  function badge(kind, href, label) {
    if (kind === '3d' || /3d|\.(igs|iges|step|stp|3ds|obj|fbx|skp|dwg|dxf)(\?|$)/i.test(label + ' ' + href)) return '3D';
    if (kind === 'dim') return 'DWG';
    if (/\.(zip|rar|7z)(\?|$)/i.test(href)) return 'ZIP';
    if (/\.(png|jpe?g|webp|gif)(\?|$)/i.test(href)) return 'IMG';
    return 'PDF';
  }
  function niceLabel(t) {
    t = t.replace(/[↓⬇→☛]/g, '').replace(/\s*\((?:\.?pdf|zip)\)\s*/ig, ' ').replace(/[:：]+$/, '').replace(/\s+/g, ' ').trim();
    if (t.length > 30) t = t.slice(0, 28).replace(/\s+\S*$/, '') + '…';
    if (t === t.toUpperCase() && t.replace(/[^a-z]/gi, '').length > 4) t = t.toLowerCase().replace(/\b3d\b/g, '3D');
    return t.charAt(0).toUpperCase() + t.slice(1);
  }
  function blank(el) { return el.nodeType === 1 && !txt(el) && !el.querySelector('img, iframe, video, a[href]'); }
  function prevEl(el) { var p = el.previousElementSibling; while (p && (blank(p) || /^(STYLE|SCRIPT|BR|META|LINK)$/.test(p.tagName))) p = p.previousElementSibling; return p; }
  // remove el, then every ancestor (below root) left with no link / media and no text beyond a heading word
  function pruneUp(el, root) {
    var p = el.parentNode; if (!p) return; p.removeChild(el);
    while (p && p !== root && p.nodeType === 1) {
      if (p.querySelector('a[href], img, iframe, video')) break;
      var t = txt(p); if (t && !HEAD_WORDS.test(t) && !(t.length < 80 && /download|resource|document|specifier/i.test(t))) break;
      var n = p.parentNode; if (!n) break; n.removeChild(p); p = n;
    }
  }
  // the label ("Downloads", "TECHNICAL DOCUMENTS") and divider sitting right above a removed group go too
  function dropHeadBefore(el, root) {
    var p = prevEl(el); if (!p || p === root) return;
    if (!p.querySelector('a[href], img') && HEAD_WORDS.test(txt(p))) { var d = prevEl(p); p.parentNode.removeChild(p); if (d && (d.tagName === 'HR' || /divider/i.test(d.className || '')) && !txt(d)) d.parentNode.removeChild(d); }
  }
  // label of a download link: its own text, else the <th>/first cell of its row, else the caption row below an icon table, else a sibling label
  function labelOf(a) {
    var lab = txt(a.closest('button') || a).replace(/^[\s☛↓⬇→]+|[\s☛↓⬇→]+$/g, '');
    if (!JUNK.test(lab)) return lab;
    var tr = a.closest('tr');
    if (tr) {
      var th = tr.querySelector('th'); if (th && txt(th)) return txt(th);
      var tds = $$(':scope > td', tr); var my = a.closest('td');
      if (tds.length > 1 && my !== tds[0] && txt(tds[0])) return txt(tds[0]);
      var nx = tr.nextElementSibling;
      if (nx && !nx.querySelector('a[href]') && txt(nx) && txt(nx).length < 60) { var ntd = $$(':scope > td', nx); var i = tds.indexOf(my); return (i >= 0 && ntd.length === tds.length) ? txt(ntd[i]) : txt(nx); }
    }
    var box = a.closest('td, li, p, div');
    if (box) { var c = txt(box).replace(txt(a), '').replace(/^[\s☛↓⬇→:]+|[\s☛↓⬇→:]+$/g, ''); if (c && c.length < 60) return c; var pv = prevEl(box); if (pv && txt(pv).length < 60) return txt(pv); }
    return lab;
  }
  // ---- placeholders: always removed (a dead button is never wanted) ----
  function killPlaceholders(root) {
    var dead = 0;
    $$('a', root).forEach(function (a) {
      var h = (a.getAttribute('href') || '').trim();
      if (!DEAD_HREF.test(h)) return;
      var lab = txt(a.closest('button') || a);
      // only download-looking links: a labelled row (spec / install / 3D …) or a download button class / container; in-page toggles (lightbox ×, "▶ watch video") stay
      if (!(family(lab, '') || /download|dl-btn|dl-link|doc-link/i.test(a.className || '') || a.closest('[class*="download"], [id*="download"], .docs-buttons-container, .dl-grid'))) return;
      if (/watch|video|▶/i.test(lab)) return;
      if (a.querySelector('img, video, iframe')) { unwrap(a); return; }
      var box = a.closest('div, li, p, section, td') || a.parentNode;
      if (a.closest('button')) { unwrap(a); return; }   // broken markup where text was sliced into href="1" links: keep the text
      box.setAttribute('data-xs-dead', '1'); a.parentNode.removeChild(a); dead++;
    });
    // PL: "↓ INSTALLATION INSTRUCTIONS (PDF)" action buttons that never got a link; "☛ Download" table cells without a link
    $$('.docs-buttons-container .action-btn, .action-btn', root).forEach(function (b) { if (!b.querySelector('a[href]') && family(txt(b), '')) { b.setAttribute('data-xs-dead', '1'); dead++; } });
    $$('tr', root).forEach(function (tr) {
      var th = tr.querySelector('th') || tr.querySelector('td'); var td = tr.querySelector('td:last-child'); if (!th || !td || th === td) return;
      if (!family(txt(th), '') || td.querySelector('a[href], img')) return;
      if (/^[\s☛↓⬇→]*(download|pdf|link)?[\s☛↓⬇→]*$/i.test(txt(td))) { tr.setAttribute('data-xs-dead', '1'); dead++; }
    });
    $$('[data-xs-dead]', root).forEach(function (box) {
      if (!box.parentNode || box.querySelector('a[href], img, iframe, video')) { box.removeAttribute('data-xs-dead'); return; }
      var t = txt(box); if (t.length > 60 && !box.matches('tr, .action-btn')) { box.removeAttribute('data-xs-dead'); return; }
      var grp = box.matches('tr, .action-btn') ? box : (box.closest('[class*="download"], [class*="docs"], [class*="dl-"], [class*="resource"]') || box); if (grp.querySelector('a[href]')) grp = box;
      pruneUp(grp, root);
    });
    // a docs container / table emptied by the above → drop it with its heading
    $$('.docs-buttons-container, table, details, div', root).forEach(function (g) {
      if (!g.parentNode || g === root || g.querySelector('a[href], img, iframe, video')) return;
      var t = txt(g); if (t && !HEAD_WORDS.test(t)) return;
      if (!/download|docs|resource|document/i.test(g.className + ' ' + g.id + ' ' + t) && g.tagName !== 'DETAILS') return;
      dropHeadBefore(g, root); pruneUp(g, root);
    });
    return dead;
  }
  // ---- real download links in the description ----
  function harvest(root, title) {
    var found = [], boxes = [], seen = {}, dropped = 0;
    function mark(a) { a.setAttribute('data-xs-doc-seen', '1'); }
    function harvestable(el) { return $$('a[href]', el).every(function (a) { return a.getAttribute('data-xs-doc-seen') || /^(mailto|tel):/i.test(a.getAttribute('href') || ''); }); }
    function add(a, label, kindHint) {
      var href = a.getAttribute('href') || ''; var kind = kindOf(label) || kindHint || '';
      if (!isDoc(href, kind)) return false;
      mark(a); var id = docId(href); var rx = WRONG[id];
      if (rx && !rx.test(title)) { dropped++; return true; }
      if (seen[id]) return true; seen[id] = 1;
      found.push({ kind: kind, href: href, label: label }); return true;
    }
    function pushBox(el) { if (el && el !== root && boxes.indexOf(el) < 0) boxes.push(el); }
    function boxFor(a) {
      var box = a, el = a.parentElement, up = 0;
      while (el && el !== root && up < 4) {
        if (!harvestable(el)) break;
        var c = el.cloneNode(true); $$('a[href], svg, style, script', c).forEach(function (x) { x.parentNode.removeChild(x); });
        var rest = (c.textContent || '').replace(/\s+/g, ' ').trim();
        if (rest.length > 80 && !HEAD_WORDS.test(rest)) break;
        if (rest.length > 40 && !HEAD_WORDS.test(rest) && /^(TBODY|TABLE|TR)$/.test(el.tagName) && el.querySelectorAll('tr').length > 3) break;   // spec table: never the whole table
        box = el; el = el.parentElement; up++;
      }
      return box;
    }
    // empty anchors (no text, no image) are invisible → drop them so they don't block a row
    $$('a[href]', root).forEach(function (a) { if (!txt(a) && !a.querySelector('img, picture, svg')) a.parentNode.removeChild(a); });
    // 1) every labelled document link
    $$('a[href]', root).forEach(function (a) {
      if (a.getAttribute('data-xs-doc-seen') || a.closest('[data-xs-docs]')) return;
      var label = labelOf(a); if (!label) return;
      if (add(a, label, '')) pushBox(boxFor(a));
    });
    // 2) plain bodies: heading followed by blocks holding (icon-only) links
    $$('h2, h3, h4, h5, p, div', root).forEach(function (h) {
      var t = txt(h); if (!t || !HEAD_WORDS.test(t) || h.querySelector('a[href]')) return;
      if (/^(P|DIV)$/.test(h.tagName) && !(h.querySelector('strong, b') || /label|title|head/i.test(h.className || ''))) return;
      var kind = kindOf(t), nx = h.nextElementSibling, group = [h], links = [];
      while (nx && (!/^H[1-4]$/.test(nx.tagName) || (!txt(nx) && nx.querySelector('a[href]')))) {
        if (/label|divider/i.test(nx.className || '') && txt(nx)) break;
        var as = $$('a[href]', nx).filter(function (a) { return !a.getAttribute('data-xs-doc-seen'); });
        as.forEach(function (a) { links.push([a, txt(a) || t, kind]); });
        if (as.length || !txt(nx)) group.push(nx);
        nx = nx.nextElementSibling;
      }
      var got = 0; links.forEach(function (l) { if (add(l[0], l[1], l[2])) got++; });
      if (got && links.length === got) group.forEach(pushBox);
    });
    boxes.slice().forEach(function (box) {
      var p = prevEl(box);
      if (p && !p.querySelector('a[href]') && HEAD_WORDS.test(txt(p)) && (/^H[2-6]$/.test(p.tagName) || /label|title|head/i.test(p.className || '') || p.querySelector('strong, b'))) {
        pushBox(p); var d = prevEl(p); if (d && (d.tagName === 'HR' || /divider/i.test(d.className || '')) && !txt(d)) pushBox(d);
      }
      var n = box.nextElementSibling; if (n && (n.tagName === 'HR' || /divider/i.test(n.className || '')) && !txt(n) && boxes.indexOf(n) < 0) { var nn = prevEl(n); if (nn === box) pushBox(n); }
    });
    return { found: found, boxes: boxes, dropped: dropped };
  }
  function docCard(kind, href, title, sub) {
    var a = document.createElement('a'); a.className = 'xs-doc'; a.href = href; a.target = '_blank'; a.rel = 'noopener'; a.setAttribute('data-xs-doc', kind || 'other');
    var i = document.createElement('i'); i.textContent = badge(kind, href, title);
    var sp = document.createElement('span'); var b = document.createElement('b'); b.textContent = title; var em = document.createElement('em'); em.textContent = sub;
    sp.appendChild(b); sp.appendChild(em); a.appendChild(i); a.appendChild(sp); return a;
  }
  var HARVESTED = null;   // description links merged once, shared by every rendered block (PL renders the info column twice: desktop + mobile)
  function docsOne(block, title) {
    if (block.dataset.xsDocsDone) return; block.dataset.xsDocsDone = '1';
    var list = $('[data-xs-docs-list]', block); if (!list) return;
    var wrap = block.closest('.xs-docs-block, .product-block, .product__block') || block;
    var labels = { spec: block.dataset.xsLSpec || 'Spec sheet', asm: block.dataset.xsLAsm || 'Installation guide', '3d': block.dataset.xsL3d || '3D files', dim: block.dataset.xsLDim || 'Dimension drawing' };
    var sub = block.dataset.xsDownload || 'Download';
    var ids = {}, titles = {}, perKind = {};
    $$('a[href]', list).forEach(function (a) { ids[docId(a.href)] = 1; titles[txt(a.querySelector('b')).toLowerCase()] = 1; var k = a.getAttribute('data-xs-doc') || 'other'; perKind[k] = (perKind[k] || 0) + 1; });
    var mfKinds = {}; Object.keys(perKind).forEach(function (k) { if (k !== 'other') mfKinds[k] = 1; });
    (block.dataset.xsHide || '').split(',').forEach(function (k) { k = k.trim().toLowerCase(); if (!k) return; var kk = kindOf(k) || k; mfKinds[kk] = 1; mfKinds['label:' + k] = 1; });
    var hasCards = $$('a[href]', list).length > 0 || !!block.dataset.xsHide;
    if (HARVESTED === null) {
      HARVESTED = [];
      $$(ROOTS).filter(function (r) { return !r.closest('[data-xs-docs]') && !r.dataset.xsHarvest; }).forEach(function (root) {
        root.dataset.xsHarvest = '1';
        try { killPlaceholders(root); } catch (e) { }
        if (!hasCards) return;   // no metafield yet → the description keeps its own links
        var r = harvest(root, title);
        r.found.forEach(function (f) { HARVESTED.push(f); });
        r.boxes.forEach(function (el) { if (el.parentNode && !el.contains(block)) { dropHeadBefore(el, root); pruneUp(el, root); } });
      });
    }
    HARVESTED.forEach(function (f) {
      var id = docId(f.href); if (ids[id]) return; ids[id] = 1;
      var k = f.kind || 'other'; if (k !== 'other' && mfKinds[k]) return; if (mfKinds['label:' + norm(f.label)]) return; perKind[k] = (perKind[k] || 0) + 1;
      var raw = norm(f.label);
      var t = raw && !GENERIC.test(raw) ? niceLabel(f.label) : (labels[k] || niceLabel(f.label || 'Document'));
      if (titles[t.toLowerCase()]) t += ' ' + perKind[k];
      titles[t.toLowerCase()] = 1; list.appendChild(docCard(k, f.href, t, sub));
    });
    var has = $$('a[href]', list).length > 0; block.hidden = !has; if (wrap !== block) wrap.hidden = !has;
  }
  function docs() {
    var blocks = $$('[data-xs-docs]'); if (!blocks.length) return;
    var titleEl = $('h1.product__title, .product__title, h1'); var title = titleEl ? txt(titleEl) : document.title;
    blocks.forEach(function (b) { docsOne(b, title); });
  }
  function init() { try { docs(); } catch (e) { if (window.console) console.warn('xs-docs', e); } }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { HARVESTED = null; $$('[data-xs-docs]').forEach(function (b) { delete b.dataset.xsDocsDone; }); $$(ROOTS).forEach(function (r) { delete r.dataset.xsHarvest; }); init(); });
})();
